import { getHttpErrorStatus } from './get-http-error-status';

export function isClientHttpError(error: unknown): boolean {
  const status = getHttpErrorStatus(error);
  return status !== null && status >= 400 && status < 500;
}
